<template>
  <a-layout-content class="wemail-sites-overview">
    <a-breadcrumb :style="{ marginBottom: '20px' }">
      <a-breadcrumb-item>
        <router-link tag="a" :to="{ name: 'sites.overview', params: { siteId: this.$route.params.siteId } }">Site</router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item>Site Health Status</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="wemail-tabs-wrap">
      <SitesNavigation/>
      <a-card :loading="loading">
          <template v-if="health">
            <table>
              <tbody v-if="health.wp">
                <tr>
                  <td colspan="2">
                    Please copy and paste this information in your ticket when contacting support:
                    <a-button type="primary">
                      <a href="JavaScript:void(0)" @click="copyToClipboard" class="button button-primary button-large float-right">
                        Copy to clipboard
                      </a>
                    </a-button>
                    <textarea id="copy-data">{{ copyable }}</textarea>
                  </td>
                </tr>
              </tbody>

              <WordPressInfo :wp="health.wp"></WordPressInfo>
              <ServerInfo :server="health.server"></ServerInfo>
              <PostTypes :post_types="health.post_types"></PostTypes>
              <TimeInfo :time_info="health.time_info"></TimeInfo>
              <Plugins :plugins="health.plugins"></Plugins>

            </table>
          </template>
        </a-card>
    </div>
  </a-layout-content>
</template>

<script>
import SitesNavigation from "@/components/SitesNavigation.vue";
import WordPressInfo from '@/components/Sites/Health/WordPressInfo.vue';
import ServerInfo from '@/components/Sites/Health/ServerInfo.vue';
import PostTypes from '@/components/Sites/Health/PostTypes.vue';
import TimeInfo from '@/components/Sites/Health/TimeInfo.vue';
import Plugins from '@/components/Sites/Health/Plugins.vue';

import Api from "@/services/Api";

export default {
  name: 'Health',
  components: {
    SitesNavigation,
    WordPressInfo,
    ServerInfo,
    PostTypes,
    TimeInfo,
    Plugins
  },
  data() {
    return {
      site: {},
      health: {},
      copyable: false,
      loading: true
    };
  },
  methods: {
    getSiteHealth() {
      this.loading = true;
      Api.get(`/sites/${this.$route.params.siteId}/health`).then(res => {
        this.health = res.data.data;
        this.copyable = this.plainText(this.health).join('\n');
        this.loading = false;
      }).catch(err => {
        this.$weNotify("error", "Failed to load data!");
        this.loading = false;
      })
    },
    getSiteDetails() {
      Api.get(`/sites/${this.$route.params.siteId}/overview/details`).then(res => {
        this.site = res.data;
        this.getSiteHealth();
      }).catch(err => {
        this.$weNotify("error", "Failed to load data!");
        this.loading = false;
      })
    },
    copyToClipboard() {
      const vm = this;
      const testingCodeToCopy = document.querySelector('#copy-data');
      testingCodeToCopy.select();

      try {
        const successful = document.execCommand('copy');
        if (successful) {
          vm.$weNotify("success", "Copied to clipboard");
        } else {
          vm.$weNotify("error", 'Failed to copy!');
        }
      } catch (err) {
        vm.$weNotify("error", 'Failed to copy!');
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden');
      window.getSelection().removeAllRanges();
    },
    plainText(data){

      if (!data) {
        return null;
      }

      let lines = [];

      if (data.hasOwnProperty('plugins')){
        lines = lines.concat(this.pluginListToText(data.plugins));
      }

      if ( data.hasOwnProperty('wp') ) {
        lines = lines.concat( this.keyValueToText( data.wp, 'WordPress INFO' ) );
      }

      if ( data.hasOwnProperty('server') ) {
        lines = lines.concat( this.keyValueToText( data.server, 'SERVER INFO' ) );
      }

      if ( data.hasOwnProperty('users') ) {
        lines = lines.concat( this.keyValueToText( data.users, 'USERS INFO' ) );
      }

      if ( data.hasOwnProperty('post_types') ) {
        lines = lines.concat( this.postTypesToText( data.post_types ) );
      }

      if ( data.hasOwnProperty('time_info') ) {
        lines = lines.concat( this.timeInfoToText( data.time_info ) );
      }

      return lines;
    },
    postTypesToText( post_types ) {
      let lines = [];

      lines[0] = '';
      lines[1] = '----------------  POST TYPES ---------------';
      var i = 2;
      for (let [key, value] of Object.entries(post_types)) {
        lines[i++] = value.type + ': ' + value.count;
      }

      lines[i++] = '';
      return lines;
    },
    pluginListToText(plugins) {
      let lines = [];

      if ( plugins.hasOwnProperty('active_plugins') ) {
        lines[0] = '';
        lines[1] = '---------------- ACTIVE PLUGINS ---------------';
        var i = 2;
        for (let [key, value] of Object.entries(plugins.active_plugins)) {
          lines[i++] = 'plugin: ' + value.name + ' | version: ' + value.version;
        }
      }

      if ( plugins.hasOwnProperty('inactive_plugins') ) {
        lines[i++] = '';
        lines[i++] = '---------------- INACTIVE PLUGINS ---------------';
        for (let [key, value] of Object.entries(plugins.inactive_plugins)) {
          lines[i++] = 'plugin: ' + value.name + ' | version: ' + value.version;
        }
      }

      return lines;
    },
    timeInfoToText( infos ) {
      let lines = [];

      lines[0] = '';
      lines[1] = '----------------  TIME INFO ---------------';
      var i = 2;
      for (let [key, value] of Object.entries(infos)) {
        lines[i++] = value.label + ': ' + value.value;
      }

      lines[i++] = '';
      return lines;
    },
    keyValueToText( object, title = '' ) {
      let lines = [];

      lines[0] = '';
      lines[1] = '---------------- ' + title + ' ---------------';
      var i = 2;
      for (let [key, value] of Object.entries(object)) {
        lines[i++] = key.replace('_', ' ') + ': ' + value;
      }

      lines[i++] = '';

      return lines;
    },
  },
  mounted() {
    this.getSiteDetails();
  }
};
</script>
<style  scoped>
.wemail-sites-overview {
  margin: 30px;
}
.wemail-overview-content table {
  border: unset;
}
#copy-data {
  position: absolute;
  z-index: -1;
  height: 0;
}
</style>
